<template>
    <d-list-group>
        <d-list-group-item>
            <p class="h6 mb-2 mt-3">Przed aktywacją wybranej bonifikaty</p>
            <table
                class="table mb-0 responsive-table"
                style="border: 1px #dee2e6 solid;table-layout: fixed;"
            >
                <thead class="bg-light">
                    <tr>
                        <th scope="col" class="border-0">
                            Kwota pożyczki dla klienta
                        </th>
                        <th scope="col" class="border-0">Kwota pożyczki</th>
                        <th scope="col" class="border-0">Prowizja</th>
                        <th scope="col" class="border-0">Koszty dodatkowe</th>
                        <th scope="col" class="border-0 text-center">
                            Odsetki
                        </th>
                        <th scope="col" class="border-0 text-right">
                            Odsetki karne
                        </th>
                        <th scope="col" class="border-0 text-right">
                            Kwota końcowa
                        </th>
                        <th scope="col" class="border-0 text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <dt>Kwota pożyczki dla klienta</dt>
                            <dd>{{ toNumber(schedule.loan_amount) }} zł</dd>
                        </td>
                        <td>
                            <dt>Kwota pożyczki</dt>
                            <dd>
                                {{ toNumber(schedule.loan_installment_sum) }} zł
                            </dd>
                        </td>
                        <td>
                            <dt>Prowizja</dt>
                            <dd>{{ toNumber(schedule.installment_sum) }} zł</dd>
                        </td>
                        <td>
                            <dt>Koszty dodatkowe</dt>
                            <dd>
                                {{ toNumber(schedule.additional_costs) }} zł
                            </dd>
                        </td>
                        <td class="text-center">
                            <dt>Odsetki</dt>
                            <dd>
                                {{
                                    toNumber(
                                        schedule.before_discount_interest_sum
                                    )
                                }}
                                zł
                                <br />
                                <small
                                    >{{
                                        toNumber(
                                            schedule.interest_rate_before_discount
                                        )
                                    }}
                                    %</small
                                >
                            </dd>
                        </td>
                        <td class="text-right">
                            <dt>Odsetki karne</dt>
                            <dd>
                                {{
                                    toNumber(
                                        schedule.before_discount_interest_penalty_sum
                                    )
                                }}
                                zł
                            </dd>
                        </td>
                        <td class="text-right">
                            <dt>Kwota końcowa</dt>
                            <dd>
                                {{
                                    toNumber(
                                        schedule.before_discount_loan_final_sum
                                    )
                                }}
                                zł
                            </dd>
                        </td>
                        <td>
                            <dt></dt>
                            <dd></dd>
                        </td>
                    </tr>
                </tbody>
            </table>
        </d-list-group-item>
    </d-list-group>
</template>

<script>
import SsDate from '@/components/common/SsDate';

export default {
  name: 'ContractLoanSummaryBeforeDiscount',
  components: {
    SsDate,
  },
  props: {
    isDraft: {
      required: true,
      type: Boolean,
    },
    schedule: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      closeDate: '',
    };
  },
  mounted() {},
  methods: {
    toNumber(number) {
      return Vue.toNumber(number);
    },
  },
};
</script>
